module.exports = __webpack_public_path__ + "static/media/onlinePickup.a3729f92.png";